import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const LoadingComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      className="nostra__icon nostra__icon__loading2"
      width={size}
      height={size}
    >
      <g clipPath="url(#clip0_3405_2810)">
        <path d="M7 1.16675V3.50008" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 10.5V12.8333" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M2.87584 2.87573L4.52667 4.52657"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.47333 9.47339L11.1242 11.1242"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M1.16667 7H3.50001" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.5 7H12.8333" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M2.87584 11.1242L4.52667 9.47339"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.47333 4.52657L11.1242 2.87573"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3405_2810">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Loading2 = withIcon(LoadingComponent);
